import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://xlvdrblrwswwqfbdosmo.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhsdmRyYmxyd3N3d3FmYmRvc21vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjExOTQ1NTksImV4cCI6MjA3Njc3MDU1OX0.LoT1tKOq0FM38_vgLTsgISTFORhSV7EaLEKdm33KCE4'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
